import Box from 'fe-design-base/atoms/Box';

interface FormFieldSpacerProps {
  height?: number;
}

// This component is used as a placeholder for spacing between form fields
// when there is no error message. This avoids other fields from moving around
// in the page when the error message is displayed.
// Please only use this if a component from the design base 'fe-design-base/atoms'
// must be used. Otherwise, use components in the 'fe-design-base/molecules' folder.

const FormFieldSpacer = ({ height = 22 }: FormFieldSpacerProps) => (
  <Box h={height} />
);

export default FormFieldSpacer;
